import { render, staticRenderFns } from "./form_item.vue?vue&type=template&id=29c59998&"
import script from "./form_item.vue?vue&type=script&lang=js&"
export * from "./form_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports